/* global espn_ui jQuery */

import React from 'react'
import { AnchorLink } from './index'
import { formatDuration } from './Video'
import { urlWithParams } from '../../lib/utils/common'

export class TopHighlights extends React.Component {

  loadVideoBehavior() {
    const videoPlaylist = this.refs.videoPlaylist

    try {
      if(!videoPlaylist.querySelectorAll('.video-playlist-item').length) {
        jQuery(this.slider).data('videoPlayListEnabled', false)
        espn_ui.loadBehaviorNamed('video_package', jQuery(videoPlaylist))
      }
    } catch(e) {
      console.log(e)
    }
  }

  componentDidMount() {
    this.loadVideoBehavior()
  }

  componentDidUpdate() {
    this.loadVideoBehavior()
  }

  render() {
    const { title = '', videos = [], href = '#', hasMoreVideosTab = false, videoCount = 3 } = this.props
    const firstVideo = videos[0] || {}
    const thumbnail = firstVideo.thumbnail
    const duration = firstVideo.duration
    const thumb = urlWithParams(thumbnail, 'w=943', 'h=530')
    let videoCountIndex = parseInt(videoCount, 10)
    videoCountIndex = isNaN(videoCountIndex) === false ? videoCountIndex : 3

    return (
      <article className="sub-module top-highlights no-thumb mediaList mediaList--highlights">
        { title ? <header> <h1>{title}</h1> </header> : null}
  
        <div className="mediaList__content">
          <ul className="mediaList__list" data-behavior="video_playlist" ref="videoPlaylist">
            <figure className="feed-item-figure video " data-source="espn" data-id={firstVideo.id} data-video={`native,640,360,${firstVideo.id}`}>
              <div className="img-wrap">
                <a name="&amp;lpos=ncf:teamclubhouse:shop" data-sport="cricket" data-mptype="image">
                  <picture>
                    <source data-srcset={thumb} media="(min-width: 414px)"/>
                    <img data-default-src={thumb} className=" lazyload" data-image-container=".feed-item-figure"/>
                  </picture>
                </a>
                <span className="video-play-button " data-playtxt="PLAY" data-id={firstVideo.id} data-autoplay="false">play</span>
                <span className="video-length">{duration ? formatDuration(duration) : ''}</span>
              </div>
            </figure>
            {
              videos.slice(0, videoCountIndex).map( (video = {}, i) => {
                const duration = video.duration
  
                return (
                  <li key={i} className="mediaList__item video-playlist-item" data-source={video.source} data-id={video.id} data-video={`native,640,360,${video.id}`} data-cerebro-id={video.cerebroId}>
                    <a className="mediaList__link">
                      <span className="mediaList__button icon-font-before icon-play-solid-before"></span>
                      <span className="mediaList__description">
                        <h3>{video.headline}</h3>
                        <span className="mediaList__time">{duration ? formatDuration(duration) : ''}</span>
                      </span>
                    </a>
                  </li>
                )
              })
            }
          </ul>
        </div>
        { hasMoreVideosTab && 
          <footer>
            <AnchorLink to={href} text="View More" />
          </footer>
        }
      </article>
    )
  }
}

export default TopHighlights



// WEBPACK FOOTER //
// ../app/components/common/TopHighlights.jsx